import type { ReactNode } from "react";
import { BottomSheet } from "@/shared/ui/BottomSheet";

const TASTO = "om-press h-12 rounded-xl px-3 text-[15px] font-semibold text-ink active:bg-paper-2";

/** Telefono: il foglio dei filtri, coi tasti Reimposta / Mostra tutti / Vedi N. */
export function OrdiniFiltriSheet({
  open,
  onClose,
  onReset,
  onShowAll,
  quanti,
  children,
}: {
  open: boolean;
  onClose: () => void;
  onReset: () => void;
  onShowAll: () => void;
  quanti: number;
  children: ReactNode;
}) {
  return (
    <BottomSheet
      open={open}
      onClose={onClose}
      title="Filtri"
      footer={
        <div className="flex items-center gap-2">
          <button type="button" onClick={onReset} className={TASTO}>
            Reimposta
          </button>
          <button type="button" onClick={onShowAll} className={TASTO}>
            Mostra tutti
          </button>
          <button
            type="button"
            onClick={onClose}
            className="om-press ml-auto h-12 rounded-xl bg-ink px-5 text-[15px] font-bold text-on-ink"
          >
            Vedi {quanti} {quanti === 1 ? "ordine" : "ordini"}
          </button>
        </div>
      }
    >
      {children}
    </BottomSheet>
  );
}
